module.exports = __webpack_public_path__ + "static/media/mulher_r1_c8.b24a3cb5.jpg";